import Markdown from "react-markdown";
import { MousePointerClick } from "lucide-react";
import { buttonClasses } from "./utils";

type ChatMessage = {
  role: "user" | "assistant";
  content: string;
};

export default function Message({
  message,
  onSelectText,
  isCompleting,
}: {
  message: ChatMessage;
  onSelectText: (text: string) => void;
  isCompleting: boolean;
}) {
  const isAssistant = message.role === "assistant";
  const boderClass = isAssistant
    ? "ring-2 ring-default-200 text-gray-700"
    : "ring-1 ring-default-200/50 text-gray-700";
  const tooltipClass = isAssistant
    ? "text-default-400 ring-1 bg-default-50 ring-default-200/50"
    : "bg-gray-50 text-gray-400 ring-1 ring-default-200/50";

  return (
    <div
      className={`${boderClass} rounded-lg shadow-lg shadow-default-50 bg-white p-6 text-gray-700 relative`}
    >
      <div
        className={`${tooltipClass} absolute top-0 left-5 text-[10px]  py-0.5 px-1 rounded-b -top-[0px]`}
      >
        {isAssistant ? "Assistant" : "Votre message"}
      </div>
      <Markdown className="leading-[24px] flex flex-col space-y-4 [&_li]:list-disc [&_li]:ml-4 [&_pre]:border [&_pre]:border-gray-200 [&_pre]:p-4 [&_pre]:overflow-x-scroll [&_pre]:rounded-lg [&_pre]:bg-gray-50 [&_code]:font-mono [&_code]:text-sm">
        {message.content}
      </Markdown>
      {!isCompleting && message.role === "assistant" && (
        <div className="flex justify-end">
          <button
            className={`${buttonClasses} text-sm !py-1 !px-2`}
            type="button"
            onClick={() => onSelectText(message.content)}
          >
            <MousePointerClick className="w-4 h-4" />
            <span>Select</span>
          </button>
        </div>
      )}
    </div>
  );
}
